import { render, staticRenderFns } from "./TemplateNew.vue?vue&type=template&id=533b6da5&"
import script from "./TemplateNew.vue?vue&type=script&lang=js&"
export * from "./TemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports